module.exports = __webpack_public_path__ + "static/assets/c1f38e604e947b7dcabb4da9769d07bd.svg";